class MeetOurProducts extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.meet-our-products__track');
    this.slides = Array.from(this.querySelectorAll('.meet-our-products__slide'));
    this.prevBtn = this.querySelector('.meet-our-products__btn--prev');
    this.nextBtn = this.querySelector('.meet-our-products__btn--next');

    this._onPrev = () => this._scroll(-1);
    this._onNext = () => this._scroll(1);
    this._onScroll = () => this._updateButtons();

    this.prevBtn?.addEventListener('click', this._onPrev);
    this.nextBtn?.addEventListener('click', this._onNext);
    this.track?.addEventListener('scroll', this._onScroll, { passive: true });

    this._updateButtons();
  }

  disconnectedCallback() {
    this.prevBtn?.removeEventListener('click', this._onPrev);
    this.nextBtn?.removeEventListener('click', this._onNext);
    this.track?.removeEventListener('scroll', this._onScroll);
  }

  _scroll(dir) {
    if (!this.track || !this.slides.length) return;

    const gap = parseInt(getComputedStyle(this.track).gap, 10) || 16;
    const slideWidth = this.slides[0].offsetWidth + gap;

    this.track.scrollBy({ left: dir * slideWidth, behavior: 'smooth' });
  }

  _updateButtons() {
    if (!this.track) return;

    const { scrollLeft, scrollWidth, clientWidth } = this.track;
    const atStart = scrollLeft <= 1;
    const atEnd = scrollLeft + clientWidth >= scrollWidth - 1;

    if (this.prevBtn) this.prevBtn.disabled = atStart;
    if (this.nextBtn) this.nextBtn.disabled = atEnd;
  }
}

customElements.define('meet-our-products', MeetOurProducts);
